import baseConfigs from './base';

export default {
  ...baseConfigs,
  apiUrl: 'https://app-dev.auto-design.io/api',
};
